const getters = {
  classDetail: state => state.detail,
  lessonId: state => {
    if (!state.detail.class_info) {
      return null;
    }

    return state.detail.class_info.course_code;
  },
  learnerAssessment: state => state.learnerAssessment,
  classWarnings: state => state.classWarnings,
};

export default getters;
